module.exports = __webpack_public_path__ + "img/kboard_ffffff.a4dd9ec5.svg";